import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import CardActions from '@material-ui/core/CardActions';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

import Icon from '../../utils/icon';
import theme from '../../utils/constants';

const useStyles = makeStyles({
  media: {
    height: '100%',
    width: '100%'
  },
  cardfeaturedtype: {
    backgroundColor: '#FDB515',
    padding: theme.spacing(0, 2.5, 0, 4),
    borderRadius: theme.spacing(0, 2, 2, 0),
    color: '#fff',
    fontWeight: 600,
    letterSpacing: 1,
    display: 'flex',
    justifyContent: 'center',
    boxShadow: '0px 0px 12px 5px rgba(253,181,21,0.3)'
  },
  cardcontenttype: {
    backgroundColor: theme.palette.primary.highlight,
    padding: theme.spacing(0, 1.5),
    borderRadius: theme.spacing(2),
    color: '#fff',
    fontWeight: 600,
    letterSpacing: 1
  },
  cards: {
    borderRadius: theme.spacing(4),
    border: '1px solid ' + theme.palette.divider
  },
  cardactions: {
    width: '100%',
    position: 'absolute',
    bottom: theme.spacing(1)
  },
  cardleftcontainer: {
    position: 'relative'
  }
});

const listCategories = (categoriesitem) => {
  return categoriesitem?.map((item, index) => {
    return (
      <Box
        key={index * Math.random() * 100}
        width={42}
        height={42}
        borderRadius={100}
        className={item.taxItemName_s}
        display='flex'
        alignItems='center'
        justifyContent='center'
        ml={1}
      >
        <Icon
          name={item.taxItemName_s}
          color='#ffffff'
          widthsize={30}
          heightsize={30}
        />
      </Box>
    );
  });
};

export default function FullWidthFeatureCard(props) {
  const { ice } = props;
  const classes = useStyles();
  return (
    <Box
      display='flex'
      className={classes.cards + ' promotionalcard'}
      component={Card}
      height={350}
      elevation={0}
    >
      <Box width={1 / 3} position='relative'>
        <Box
          width={1}
          pl={4}
          pt={4}
          pb={1}
          pr={2}
          display='flex'
          justifyContent='space-between'
          alignItems='center'
        >
          <Icon name={props.icon} widthsize={32} heightsize={32} />
        </Box>
        <CardContent>
          <Box px={2}>
            <Box pb={1}>
              <Typography
                variant='overline'
                gutterBottom
                style={{ lineHeight: 1.5 }}
              >
                {props.subtitle}
              </Typography>
              <Typography
                {...ice}
                variant='h5'
                gutterBottom
                style={{ paddingTop: 4 }}
              >
                {props.title}
              </Typography>
            </Box>
            <Box color={theme.palette.primary.light}>
              <Typography className='line-clamp'>{props.snippet}</Typography>
            </Box>
          </Box>
        </CardContent>
        <CardActions className={classes.cardactions + ' cardactionsie'}>
          <Box display='flex' justifyContent='flex-end' width={1} px={1}>
            <Button href={props.link} color='secondary'>
              {props.buttontext}
            </Button>
          </Box>
        </CardActions>
      </Box>
      <Box
        width={2 / 3}
        className={classes.cardleftcontainer + ' cardleftcontainerie'}
      >
        <Box position='absolute' left={12} top={0} zIndex={1}>
          <Box
            width={1}
            p={2}
            display='flex'
            justifyContent='space-between'
            alignItems='center'
          >
            <Typography
              variant='overline'
              className={classes.cardcontenttype}
              gutterBottom
            >
              {props.contenttype}
            </Typography>
          </Box>
        </Box>
        <Box position='absolute' top={8} right={12} display='flex' zIndex={1}>
          {listCategories(props.categories)}
        </Box>
        <CardMedia className={classes.media} image={props.image} />
      </Box>
    </Box>
  );
}
